import React, { ReactElement } from 'react';
import EditDashboardPage from 'adapter/in/dashboards/pages/EditDashboard';
import { useDashboardEdit } from 'adapter/in/dashboards/context/EditDashboard';
import { useAlertToaster } from 'adapter/in/common/context/Alert';
import { StyledAlertType } from 'adapter/in/common/components/Home/Home';

type DashboardContainerProps = {
    id: string;
};

export const EditDashboardContainer = (props: DashboardContainerProps): ReactElement => {
    const { id } = props;
    const { showSidePanelMenu } = useDashboardEdit();
    const { type: alertType, message: alertMessage, style, show: showAlert } = useAlertToaster();
    return (
        <EditDashboardPage
            id={id}
            alertType={alertType as StyledAlertType}
            showSidePanelMenu={showSidePanelMenu}
            alertMessage={alertMessage}
            animationStyle={style}
            showAlert={showAlert}
        />
    );
};
